import {combineReducers} from '@modifi/redux'

import taskReducer from './tasks/store'
import assignTaskToAccountOwnerReducer from './tasks/stores/assign-task-to-account-owner'

export default combineReducers({
  tasks: taskReducer,
  assignTaskToAccountOwner: assignTaskToAccountOwnerReducer,
})
